import { useState } from "react";

import type { ColDef } from "@/components/admin/shared/AdminTable";
import { AdminTable } from "@/components/admin/shared/AdminTable";
import { PageHeader, ViewButton } from "@/components/admin/shared/PageHeader";
import { useApprovalQueue } from "@/hooks/useApprovals";
import type { ApprovalQueueItem } from "@/api/approvals";
import { TaskDetailModal } from "@/components/admin/tasks/TaskDetailModal";

function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
}

export const ApprovalsPage = () => {
  const { data, isLoading, isError } = useApprovalQueue({ limit: 100 });
  const [openTaskId, setOpenTaskId] = useState<string | null>(null);
  const rows = data?.items ?? [];

  const cols: ColDef<ApprovalQueueItem>[] = [
    { header: "Assigned", render: (r) => fmtDate(r.assignedAt) },
    { header: "Flow", render: (r) => r.flowType },
    { header: "Step", render: (r) => `${r.stepOrder}. ${r.stepName}` },
    { header: "Task ID", render: (r) => r.taskId.slice(0, 8) },
    {
      header: "Action",
      render: (r) => <ViewButton onClick={() => setOpenTaskId(r.taskId)} />,
    },
  ];

  return (
    <>
      <PageHeader title="Approvals" subtitle="Tasks awaiting your decision." />
      <AdminTable
        columns={cols}
        rows={rows}
        keyExtractor={(r) => r.assignmentId}
        loading={isLoading}
        emptyMessage={isError ? "Could not load approvals." : "No pending approvals."}
      />
      {openTaskId && (
        <TaskDetailModal taskId={openTaskId} onClose={() => setOpenTaskId(null)} />
      )}
    </>
  );
};
